import { SparksLottie } from 'components/LottieFiles';
import {
  ButtonIcon,
  ButtonWrapper,
  Wrapper,
} from './QuestsSwiperButton.styles';
import butFleche from 'assets/icons/butFleche.png';
import { questButtonProps } from './QuestsSwiperButton.types';

const QuestsSwiperButton = ({ onClick, ...rest }: questButtonProps) => {
  return (
    <Wrapper onClick={onClick} {...rest}>
      <SparksLottie className="!w-full !h-full absolute top-0 left-0 z-20" />
      <ButtonWrapper>
        <ButtonIcon src={butFleche} alt="show-all" />
      </ButtonWrapper>
    </Wrapper>
  );
};

export default QuestsSwiperButton;
